import { useEffect, useRef, useState } from 'react';

import type { RefObject } from 'react';

type Params = { step: number; stepLabel: string };
type UseStepChangeFocus = { stepAnnouncement: string; stepContainerRef: RefObject<HTMLDivElement> };

/**
 * Al cambiar de paso (no en la carga inicial) lleva el foco al `h1` del paso nuevo y devuelve su
 * etiqueta para anunciarla: si el control con foco era del paso anterior, el foco caería en `body`.
 */
function useStepChangeFocus({ step, stepLabel }: Params): UseStepChangeFocus {
  const stepContainerRef = useRef<HTMLDivElement>(null);
  const previousStepRef = useRef<number>(step);
  const [stepAnnouncement, setStepAnnouncement] = useState<string>('');

  useEffect(() => {
    if (previousStepRef.current === step) return;
    previousStepRef.current = step;
    stepContainerRef.current?.querySelector<HTMLElement>('h1')?.focus();
    setStepAnnouncement(stepLabel);
  }, [step, stepLabel]);

  return { stepAnnouncement, stepContainerRef };
}

export default useStepChangeFocus;
